import { useMocks } from '../../shared/env';
import type { AccountingGateway } from './AccountingGateway';
import { HttpAccountingGateway } from './HttpAccountingGateway';
import { MockAccountingGateway } from './MockAccountingGateway';

export const accountingGateway: AccountingGateway = useMocks ? new MockAccountingGateway() : new HttpAccountingGateway();
export type { AccountingGateway } from './AccountingGateway';
